import "./videoOverlay.scss";
import { ReactComponent as IconClose } from "static/icons/close.svg";
import classNames from "classnames";
import React, { useState, useEffect } from "react";
import { useStore } from "shell/store/store";

interface videoOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}

const VideoOverlay: React.FC<videoOverlayProps> = (props) => {
  const [renderIframe, setRenderIframe] = useState(false);
  const language = useStore((state) => state.language);

  useEffect(() => {
    setRenderIframe(props.isOpen);
  }, [props.isOpen]);

  const doRenderIframe = () => {
    const iFrameSrc = language === 'fr' ? "https://www.youtube.com/embed/uuSBQM_pUiw" : "https://www.youtube.com/embed/LggLFwby84I";


    if (renderIframe) {
      return (
        <iframe
          width="1280"
          height="720"
          src={iFrameSrc + "?version=3&autoplay=1&controls=0&modestbranding=1"}
          title="YouTube video player"
          allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      );
    }
    return false;
  };


  return (
    <div className={classNames("video-overlay", { "is-open": props.isOpen })}>
      <IconClose className="video-overlay__close" onClick={props.onClose} />
      <div className="video-overlay__inner">
        <div className="video-overlay__wrapper wrapper">{doRenderIframe()}</div>
      </div>
    </div>
  );
};

export default VideoOverlay;
